import {ShowFileModalForm} from './ShowFileModalForm'

const ShowFileModalFormWrapper = () => {
  return <ShowFileModalForm />
}

export {ShowFileModalFormWrapper}
